import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";

import { DownloadIcon } from "@prequel/shared-components";

import { useOrg } from "@/api/queries/orgs";
import { useUser } from "@/api/queries/users";

type DownloadMenuProps = {
  menuItems: Array<{ text: string; onClick: () => void }>;
};

const DownloadMenu = ({ menuItems }: DownloadMenuProps) => {
  // Prefetch org and user data
  useOrg();
  useUser();

  return (
    <Menu as="div" className="size-full">
      <Menu.Button
        className="
          my-1 rounded-md p-1 text-gray-700
          hover:bg-neutral-200
          focus:ring-2 focus:ring-emerald-600 focus:ring-offset-2
        "
      >
        <span className="">
          <DownloadIcon className="size-5 stroke-gray-600 stroke-[1.5]" />
        </span>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="
            absolute right-4 z-10 mt-2 w-60 rounded-md bg-white shadow-lg ring-1 ring-black/5
            focus:outline-none
          "
        >
          <div className="w-full py-1">
            {menuItems.map((menuItem, key) => (
              <Menu.Item key={key}>
                {({ active }) => (
                  <button
                    onClick={menuItem.onClick}
                    className={`
                      ${active ? "bg-slate-100 text-slate-900" : "text-slate-700"}
                      flex w-full px-4 py-2 text-sm
                    `}
                  >
                    {menuItem.text}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
export default DownloadMenu;
